
  import * as ipxStaticRuntime$CPPXuDzVgfXsoam3vEvArh0xDjv_NJl8TRB6BcamR2o from 'D:/laragon/www/dabminton/halaman-admin/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "png",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipxStatic']: { provider: ipxStaticRuntime$CPPXuDzVgfXsoam3vEvArh0xDjv_NJl8TRB6BcamR2o, defaults: {} }
    }
  }
